export const UPDATE_MANAGEMENT_FILTER_CLIENT = "UPDATE_MANAGEMENT_FILTER_CLIENT";
export const UPDATE_MANAGEMENT_FILTER_STATUS = "UPDATE_MANAGEMENT_FILTER_STATUS";
export const UPDATE_MANAGEMENT_FILTER_RANGE = "UPDATE_MANAGEMENT_FILTER_RANGE";
export const UPDATE_MANAGEMENT_FILTER_DEFAULT = "UPDATE_MANAGEMENT_FILTER_DEFAULT";
export const MANAGEMENT_FILTER_GET_CLIENTS = "MANAGEMENT_FILTER_GET_CLIENTS";
export const MANAGEMENT_FILTER_GET_CLIENTS_SUCCESS = "MANAGEMENT_FILTER_GET_CLIENTS_SUCCESS";
export const MANAGEMENT_FILTER_FORM_SUBMIT = "MANAGEMENT_FILTER_FORM_SUBMIT";